import { Injectable } from '@angular/core'
import { Http, Response } from '@angular/http'

import { AngularFireAuth } from 'angularfire2/auth'
import * as firebase from 'firebase/app'

import { Observable } from 'rxjs/Observable'

import { FacebookProviderData } from './facebook-provider-data.model'

@Injectable()
export class AuthService {
    public currentUser: firebase.User

    constructor(private afAuth: AngularFireAuth,
      private http: Http) {
        this.afAuth.authState
          .subscribe((user: firebase.User) => {
            this.currentUser = user
          })
    }

    public isAuthenticated() {
      return this.afAuth.authState
        .map((auth) => {
          return auth !== null
        })
    }

    signInWithFacebook(): Promise<FacebookProviderData> {
        return <Promise<any>>this.afAuth.auth.signInWithPopup(this.getProvider())
          .then((result: any) => {
              const uid = result.user.uid
              const token = result.credential.accessToken
              return this.retrieveProfileData(uid, token)
          })
    }

    signOut(): void {
      this.afAuth.auth.signOut()
    }

    private getProvider(): firebase.auth.FacebookAuthProvider {
        const provider = new firebase.auth.FacebookAuthProvider()
        provider.addScope('email')
        provider.addScope('user_birthday')
        provider.addScope('user_photos')

        return provider
    }

    private getFacebookData(token): Promise<any> {
      return this.http.get(`https://graph.facebook.com/me?fields=email,first_name,last_name,gender,birthday&access_token=${token}`)
        .toPromise()
        .then((response: Response) => response.json())
    }

    private getFacebookPicture(token): Promise<any> {
      return this.http.get(`https://graph.facebook.com/me/picture?type=large&redirect=false&access_token=${token}`)
        .toPromise()
        .then((response: Response) => {
          const json = response.json()
          return json.data.url
        })
    }

    private retrieveProfileData(uid: string, token: string): Promise<FacebookProviderData> {
      const promiseBatch: Promise<any>[] = [
        this.getFacebookData(token),
        this.getFacebookPicture(token),
      ]

      return Promise.all(promiseBatch)
        .then((results: any) => {
          const profile = results[0]
          const imageUrl = results[1]

          const data: FacebookProviderData = {
            uid: uid,
            email: profile.email,
            firstname: profile.first_name,
            lastname: profile.last_name,
            birthday: profile.birthday,
            gender: profile.gender,
            imageUrl: imageUrl
          }

          return data
        })
    }
}



// WEBPACK FOOTER //
// C:/Users/florian.gadal/Workspace/cinenow-web/src/app/auth/auth.service.ts